import { render, staticRenderFns } from "./OfferForm.vue?vue&type=template&id=a56cb67e&scoped=true"
import script from "./OfferForm.vue?vue&type=script&lang=js"
export * from "./OfferForm.vue?vue&type=script&lang=js"
import style0 from "./OfferForm.vue?vue&type=style&index=0&id=a56cb67e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56cb67e",
  null
  
)

export default component.exports